import React, { useState, useEffect } from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import footer1 from "../assets/images/footer-1.png";
import footer2 from "../assets/images/footer-2.png";
import footer3 from "../assets/images/footer-3.png";
import footer4 from "../assets/images/footer-4.png";
import downloadbutton1 from "../assets/images/download-button-1.png";
import downloadbutton2 from "../assets/images/download-button-2.png";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import YouTubeIcon from "@mui/icons-material/YouTube";
import XIcon from "@mui/icons-material/X";
import CopyrightIcon from "@mui/icons-material/Copyright";
import ParticleText from "./ParticleText";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { fetchAPI } from "../utils/api";

function Footer({ trustedDesc }) {
  const [desc, setDesc] = useState(trustedDesc || "");
  const location = useLocation();
  const isHomePage = location.pathname === "/" || location.pathname === "";

  useEffect(() => {
    if (isHomePage) {
      if (!trustedDesc) {
        fetchAPI("HomeController")
          .then((res) => {
            if (
              res.status === 200 &&
              res.result &&
              res.result.home_trusted_healthcare_desc
            ) {
              setDesc(res.result.home_trusted_healthcare_desc);
            }
          })
          .catch((err) => {
            console.error("Error fetching footer data:", err);
          });
      } else {
        setDesc(trustedDesc);
      }
    }
  }, [trustedDesc, isHomePage]);

  return (
    <>
      <div className="footer_main">
        {isHomePage && (
          <div className="footer_content_uper">
            <div className="container-fluid">
              {desc ? (
                <div dangerouslySetInnerHTML={{ __html: desc }} />
              ) : (
                <>
                  <h4>Trusted Healthcare at Your Doorstep</h4>
                  <p>
                    CaresAtHome provides professional healthcare services
                    including nursing care, diagnostics, ICU setup, doctor
                    consultations, physiotherapy, and emergency medical support
                    with trusted healthcare professionals.
                  </p>
                  <ol>
                    <li>Verified Medical Experts</li>
                    <li> 24/7 Healthcare Support</li>
                    <li> Affordable Care Solutions</li>
                    <li> Fast Appointment Booking</li>
                  </ol>

                  <div>
                    <h4>Complete Healthcare Solutions</h4>
                    <p>
                      We offer personalized medical and caregiving services
                      designed to provide comfort, safety, and quality
                      healthcare support at home and hospital.
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <div className="footer_uper_container">
          <div className="container-fluid">
            <div className="uper_footer">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="icon_text_uf">
                    <img src={footer1} alt="footer-img-1" />
                    <p>Experienced & Verified Professionals</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="icon_text_uf">
                    <img src={footer2} alt="footer-img-2" />
                    <p>Personalized Care Plans</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="icon_text_uf">
                    <img src={footer3} alt="footer-img-3" />
                    <p>On Time Service & Support</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="icon_text_uf">
                    <img src={footer4} alt="footer-img-4" />
                    <p>Safe, Reliable & Affordable</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lower_footer">
          <div className="container-fluid">
            <div className="mobile_footer">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Quick Links
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <ul>
                        <li>
                          <Link to="/about">
                            <ArrowRightIcon /> About Us
                          </Link>
                        </li>
                        <li>
                          <Link to="/blogs">
                            <ArrowRightIcon /> Blog
                          </Link>
                        </li>
                        {/* <li>
                          <Link to="/faq">
                            <ArrowRightIcon /> FAQs
                          </Link>
                        </li> */}
                        <li>
                          <Link to="/contact">
                            <ArrowRightIcon /> Contact Us
                          </Link>
                        </li>
                        <li>
                          <Link to="/needhelp">
                            {" "}
                            <ArrowRightIcon />
                            Need Help
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Services
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <ul>
                        <li>
                          <Link to="/home-nursingcare">
                            <ArrowRightIcon /> Nursing Care
                          </Link>
                        </li>
                        <li>
                          <Link to="/nursingcare">
                            <ArrowRightIcon /> Physiotherapy
                          </Link>
                        </li>
                        <li>
                          <Link to="/nursingcare">
                            <ArrowRightIcon /> Bedside Attendent
                          </Link>
                        </li>
                        <li>
                          <Link to="/icumain">
                            <ArrowRightIcon /> ICU Setup
                          </Link>
                        </li>
                        {/* <li><Link to="/nursingcare"><ArrowRightIcon/> Emergency Services</Link></li>  */}
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Medical Support
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <ul>
                        <li>
                          <a href="#">
                            <ArrowRightIcon /> Doctor Consultant
                          </a>
                        </li>
                        {/* <li><a href="#"><ArrowRightIcon/> Diagnostics</a></li>
                                    <li><Link to="/labtest"><ArrowRightIcon/> Lab Tests</Link></li> */}
                        {/* <li><a href="#"><ArrowRightIcon/> Medicines</a></li> */}
                        <li>
                          <Link to="/product-on-rent">
                            <ArrowRightIcon />
                            Products on Rent
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapsefour"
                      aria-expanded="false"
                      aria-controls="collapsefour"
                    >
                      Help
                    </button>
                  </h2>
                  <div
                    id="collapsefour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <ul>
                        <li>
                          <Link to="/privacy-policy">
                            <ArrowRightIcon /> Privacy Policy
                          </Link>
                        </li>
                        <li>
                          <Link to="/return-policy">
                            <ArrowRightIcon /> Return Policy
                          </Link>
                        </li>
                        <li>
                          <Link to="/terms-and-condition">
                            <ArrowRightIcon /> Terms & Condition
                          </Link>
                        </li>
                        <li>
                          <Link to="/refund-cancellation-policy">
                            <ArrowRightIcon /> Refund & Cancellation Policy
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fooer_list">
                <h4>Contact Us</h4>
                <ul className="info_footer">
                  <li>
                    {" "}
                    <a href="tel:+919521111603">
                      {" "}
                      <LocalPhoneOutlinedIcon /> <span>+91-95211-11603</span>
                    </a>
                  </li>
                  <li>
                    {" "}
                    <a href="mailto:info@caresathome.com">
                      {" "}
                      <MailOutlineOutlinedIcon />{" "}
                      <span> info@caresathome.com</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="lower_footer_inner">
              {/* <!-- Registration CTA --> */}
              <div class="join-strip">
                <div class="join-text">
                  <div>
                    <b>Are you a Healthcare Professional?</b>
                    <span>
                      Join CareAtHome as a caregiver, nurse or consulting doctor
                      — verified in 24–48 hours.
                    </span>
                  </div>
                </div>
                <div class="join-actions">
                  <a href="/registration" class="btn-mint">
                    Caregiver Partner Registration
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.5"
                      stroke-linecap="round"
                    >
                      <path d="M7 17L17 7M9 7h8v8" />
                    </svg>
                  </a>
                  <a href="/registration" class="btn-mint-outline">
                    Doctor Registration
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.5"
                      stroke-linecap="round"
                    >
                      <path d="M7 17L17 7M9 7h8v8" />
                    </svg>
                  </a>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-2 col-md-6 col-12">
                  <div className="fooer_list">
                    <h4>Quick Links</h4>
                    <ul>
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>
                      <li>
                        <Link to="/blogs">Blog</Link>
                      </li>
                      {/* <li>
                        <Link to="/faq"> FAQs</Link>
                      </li> */}
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/needhelp">Need Help</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-12">
                  <div className="fooer_list">
                    <h4>Services</h4>
                    <ul>
                      <li>
                        <Link to="/home-nursingcare">Nursing Care</Link>
                      </li>
                      <li>
                        <Link to="/home-physiotherapy">Physiotherapy</Link>
                      </li>
                      <li>
                        <Link to="/home-bedsideattendant">
                          Bedside Attendant
                        </Link>
                      </li>
                      <li>
                        <Link to="/icu-installation-at-home">
                          ICU Setup At Home
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-12">
                  <div className="fooer_list">
                    <h4>Medical Support</h4>
                    <ul>
                      <li>
                        <Link to="/icu-installation-at-hospital">
                          ICU Setup At Hospital
                        </Link>
                      </li>
                      <li>
                        <Link to="/doctor-consultation-services">
                          Doctor Consultant
                        </Link>
                      </li>
                      {/* <li><Link to="/labtest">Diagnostics</Link></li>
                                    <li><Link to="/labtest">Lab Tests</Link></li> */}
                      {/* <li><Link to="/medicine">Medicines</Link></li> */}
                      <li>
                        <Link to="/product-on-rent">Products on Rent</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12">
                  <div className="fooer_list">
                    <h4>Help</h4>
                    <ul>
                      <li>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/return-policy">Return Policy</Link>
                      </li>
                      <li>
                        <Link to="/terms-and-condition">Terms & Condition</Link>
                      </li>
                      <li>
                        <Link to="/refund-cancellation-policy">
                          Refund & Cancellation Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12">
                  <div className="fooer_list last">
                    <h4>Contact Us</h4>
                    <ul className="info_footer">
                      <li>
                        {" "}
                        <a href="tel:+919521111603">
                          {" "}
                          <LocalPhoneOutlinedIcon />{" "}
                          <span>+91-95211-11603</span>
                        </a>
                      </li>
                      <li>
                        {" "}
                        <a href="mailto:info@caresathome.com">
                          {" "}
                          <MailOutlineOutlinedIcon />{" "}
                          <span> info@caresathome.com</span>
                        </a>
                      </li>
                    </ul>
                    <a
                      class="wa"
                      href="https://wa.me/919521111603"
                      target="_blank"
                    >
                      <span class="wa-ic">
                        <WhatsAppIcon />
                      </span>
                      <span>
                        <small>Get A Quick Reply</small>
                        <b>Chat on WhatsApp</b>
                      </span>
                      <svg class="arr" viewBox="0 0 24 24">
                        <path d="M5 12h14M13 6l6 6-6 6" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="media_icons_footer">
                <div className="downd_btnss">
                  <Link
                    to="https://play.google.com/store/search?q=Caresathome&c=apps&hl=en_IN"
                    target="_blank"
                  >
                    <img src={downloadbutton1} alt="downloadbutton-1" />
                  </Link>
                  <Link
                    to="https://play.google.com/store/search?q=Caresathome&c=apps&hl=en_IN"
                    target="_blank"
                  >
                    <img src={downloadbutton2} alt="downloadbutton-2" />
                  </Link>
                </div>
                <div className="media_icons_main_footer">
                  <a
                    href="https://www.facebook.com/caresathome/"
                    target="_blank"
                  >
                    <FacebookIcon />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/caresathome?original_referer=https%3A%2F%2Fcaresathome%2Ecom%2F&originalSubdomain=in"
                    target="_blank"
                  >
                    <LinkedInIcon />
                  </a>
                  <a
                    href="https://www.instagram.com/caresathome/"
                    target="_blank"
                  >
                    <InstagramIcon />
                  </a>

                  <a
                    href="https://www.youtube.com/channel/UCIEkL7Xb8G_9dltD4nyCkHg"
                    target="_blank"
                  >
                    <YouTubeIcon />
                  </a>
                  <a href="https://x.com/cares_at_home" target="_blank">
                    <XIcon />
                  </a>
                </div>
                <div className="copy_right">
                  <CopyrightIcon />
                  <span>2026 Cares At Home. All Rights Reserved.</span>
                </div>
              </div>
            </div>

            <div className="keyword_section">
              <div className="inner_div_keywords">
                <p>
                  <a href="/" target="_blank" rel="noopener">
                    Home healthcare
                  </a>
                  <a href="/" target="_blank" rel="noopener">
                    Home care
                  </a>
                  <a href="/home-nursingcare" target="_blank" rel="noopener">
                    Home nursing{" "}
                  </a>
                  <a href="/home-nursingcare" target="_blank" rel="noopener">
                    Nursing care{" "}
                  </a>
                  <a href="/home-nursingcare" target="_blank" rel="noopener">
                    Patient care{" "}
                  </a>
                  <a href="/home-nursingcare" target="_blank" rel="noopener">
                    Elderly care{" "}
                  </a>
                  <a href="/home-physiotherapy" target="_blank" rel="noopener">
                    Home physiotherapy{" "}
                  </a>
                  <a
                    href="/home-bedsideattendant"
                    target="_blank"
                    rel="noopener"
                  >
                    Palliative care{" "}
                  </a>
                  <a href="/home-nursingcare" target="_blank" rel="noopener">
                    Caregiver services{" "}
                  </a>
                  <a href="/home-nursingcare" target="_blank" rel="noopener">
                    Patient attendant{" "}
                  </a>
                  <a href="/product-on-rent" target="_blank" rel="noopener">
                    Medical equipment{" "}
                  </a>
                  <a href="/home-nursingcare" target="_blank" rel="noopener">
                    Nursing care services{" "}
                  </a>
                  <a href="/" target="_blank" rel="noopener">
                    Home health care services{" "}
                  </a>
                  <a href="/home-nursingcare" target="_blank" rel="noopener">
                    Patient care services{" "}
                  </a>
                  <a
                    href="/icu-installation-at-home"
                    target="_blank"
                    rel="noopener"
                  >
                    ICU setup at home{" "}
                  </a>
                  <a href="/home-nursingcare" target="_blank" rel="noopener">
                    Home Nursing Care{" "}
                  </a>
                  <a href="/home-physiotherapy" target="_blank" rel="noopener">
                    Physiotherapy at Home{" "}
                  </a>
                  <a
                    href="/doctor-consultation-services"
                    target="_blank"
                    rel="noopener"
                  >
                    Doctor Home Visits{" "}
                  </a>
                  <a
                    href="/doctor-consultation-services"
                    target="_blank"
                    rel="noopener"
                  >
                    Online Doctor Consultation{" "}
                  </a>
                  <a
                    href="/home-bedsideattendant"
                    target="_blank"
                    rel="noopener"
                  >
                    Elderly Care Services{" "}
                  </a>
                  <a
                    href="/home-bedsideattendant"
                    target="_blank"
                    rel="noopener"
                  >
                    Bedside Attendant Services{" "}
                  </a>
                </p>
              </div>
            </div>

            <div className="big_heading_footer">
              <div className="canvas_animation">
                <ParticleText />
              </div>
              <h2>CaresATHome</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="sticky-enqry">
        <a
          href="https://wa.me/919521111603"
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsAppIcon />
        </a>
      </div>
    </>
  );
}

export default Footer;
